import { faSparkles } from "@fortawesome/pro-solid-svg-icons/faSparkles";
import * as React from "react";
import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconAI: React.FC<Omit<MprcIconFaProps, "icon" | "color">> = (props) => {
    return <MprcIconFa {...props} icon={faSparkles} style={{ color: "#d964e8" }} />;
};
